import classNames from 'classnames';
import {filter, map, orderBy} from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import swal from 'sweetalert2';
import {updatePlayer} from '../../../../../actions/app/onSite/players/listWidget';
import {fetchTdsIfNeeded} from '../../../../../actions/app/tools/tds/listWidget';
import {
  fetchFullPlayers,
  importOpta,
  updateDataByChampionshipId,
  updateListProd,
} from '../../../../../actions/entities/player';
import {
  championshipsById,
  ChampionshipSelector,
} from '../../../../../components/ChampionshipSelector';
import Icon from '../../../../../components/Icon';
import Loader from '../../../../../components/Loader';
import copyToClipboard from '../../../../../helpers/copyToClipboard';
import {playerStatusById} from '../../../../Tools/Tds/Widgets/TdsList/iconManager';
import {
  getChampionshipClubsByChampionshipId,
  getNextGameWeekByChampiomshipId,
} from '../../../../Tools/Tds/Widgets/TdsList/index';
// import {
//   updateSuggestedQuotationsPlayers,
//   applySuggestedQuotationsPlayers
// } from '../../../../../actions/app/onSite/suggestedQuotations';
import CheckPlayers from '../CheckPlayers';
import JobsStates from '../JobsStates';
import './PlayersListWidget.css';

const initialState = {
  championship: 1,
  filters: {},
  orderBy: 'quotation',
  sortOrder: 'desc',
  players: {entities: []},
  focusedInputValue: '',
  protectedInputs: {
    position: true,
    ultraPosition: true,
    quotation: true,
    active: true,
  },
  onlyActive: true,
  dataToggle: true,
};

class PlayersListWidget extends React.Component {
  constructor(props) {
    super(props);

    const state = initialState;
    if (props.championship) state.championship = props.championship;

    this.state = state;
  }

  fetchPlayersList = e => {
    if (e) e.preventDefault();
    const {championship} = this.state;
    this.props.dispatch(fetchFullPlayers({championship}));
  };

  // updatePlayerQuotation(key, e) {
  //   if (e) e.preventDefault();
  //   const player = this.state.players[key];
  //   player &&
  //     parseInt(player.suggestedQuotation, 10) !==
  //       parseInt(this.state.focusedInputValue, 10) &&
  //     this.props.dispatch(
  //       updateSuggestedQuotationsPlayers({
  //         id: this.props.suggestedQuotationsId,
  //         playerId: player.id,
  //         suggestedQuotation: e.target.value
  //       })
  //     );
  // }

  updatePlayerProperty(property, key, e) {
    if (e) e.preventDefault();
    const player = this.state.players[key];
    player &&
      this.props.dispatch(
        updatePlayer(player.id, {[property]: player[property] || undefined}),
      );
  }

  displayRequestMessage(info = this.props.widget.info) {
    if (info.error) {
      switch (info.error) {
        default:
          swal({
            title: `Oops...`,
            type: 'error',
            html:
              `Something went wrong with: "${info.lastAction}"<br/>` +
              `<pre><code>${JSON.stringify(info, undefined, 4)}</code></pre>`,
          });
      }
    }
  }

  selectOrChangeOrder(orderType) {
    if (orderType === this.state.orderBy)
      this.setState({
        sortOrder: this.state.sortOrder === 'asc' ? 'desc' : 'asc',
      });
    else {
      this.setState({orderBy: orderType});
      // The switch is necessary for the default sortOrder each orderType
      switch (orderType) {
        case 'club':
          this.setState({sortOrder: 'asc'});
          break;
        case 'name':
          this.setState({sortOrder: 'asc'});
          break;
        case 'position':
          this.setState({sortOrder: 'asc'});
          break;
        case 'quotation':
          this.setState({sortOrder: 'desc'});
          break;
        case 'ultraPosition':
          this.setState({sortOrder: 'asc'});
          break;
        case 'variation':
          this.setState({sortOrder: 'desc'});
          break;
        default:
          this.setState({sortOrder: 'asc'});
      }
    }
  }

  orderPlayers(players) {
    const {championshipClubsById, nextGameWeek} = this.state;
    const {tds} = this.props;
    // The switch is necessary for the default second order of each orderType
    switch (this.state.orderBy) {
      case 'club':
        return orderBy(
          players,
          [
            player =>
              championshipClubsById &&
              championshipClubsById[player.clubId] &&
              championshipClubsById[player.clubId].name['fr-FR'],
            'position',
          ],
          [this.state.sortOrder, 'asc'],
        );
      case 'name':
        return orderBy(
          players,
          ['lastName', 'quotation'],
          [this.state.sortOrder, 'desc'],
        );
      case 'Status':
        return orderBy(
          players,
          [
            player =>
              nextGameWeek &&
              tds.data &&
              tds.data.gameWeeks[nextGameWeek] &&
              tds.data.gameWeeks[nextGameWeek].playersStatuses[player.id],
            'quotation',
          ],
          [this.state.sortOrder, 'desc'],
        );
      case 'position':
        return orderBy(
          players,
          ['position', 'lastName'],
          [this.state.sortOrder, 'asc'],
        );
      case 'ultraPosition':
        return orderBy(
          players,
          ['ultraPosition', 'lastName'],
          [this.state.sortOrder, 'asc'],
        );
      case 'variation':
        return orderBy(
          players,
          // Just to put NaN before the 0
          [
            p => {
              return p.productionQuotation == null
                ? -1
                : Math.abs(p.productionQuotation - p.quotation);
            },
            'lastName',
          ],
          [this.state.sortOrder, 'asc'],
        );
      default:
        return orderBy(
          players,
          ['quotation', 'lastName'],
          [this.state.sortOrder, 'asc'],
        );
    }
  }

  getOrderCaret(orderType) {
    if (orderType !== this.state.orderBy) return false;

    return `fa-caret-${this.state.sortOrder === 'desc' ? 'down' : 'up'}`;
  }

  filterPlayers(players) {
    if (this.state.onlyActive) {
      players = filter(players, 'active');
    } else {
      players = filter(players, p => !p.active);
    }
    map(this.state.filters, (value, key) => {
      if (value && value !== '') {
        switch (key) {
          case 'name':
            players = filter(
              players,
              player =>
                (player.lastName &&
                  player.lastName.match(new RegExp(value, 'gi'))) ||
                (player.firstName &&
                  player.firstName.match(new RegExp(value, 'gi'))) ||
                player.id.match(new RegExp(value, 'gi')),
            );
            break;
          case 'club':
            players = filter(players, {clubId: value});
            break;
          case 'position':
            players = filter(players, {position: parseInt(value, 10)});
            break;
          case 'ultraPosition':
            players = filter(players, player => {
              if (value === 'Unknown') {
                if (!player.ultraPosition) {
                  return player;
                }
              } else {
                return player.ultraPosition === parseInt(value, 10);
              }
            });
            break;
          case 'quotation':
            players = filter(
              players,
              player => player.quotation >= parseInt(value, 10),
            );
            break;
          default:
            return players;
        }
      }
    });

    return players;
  }

  protectInput(inputName) {
    const {protectedInputs} = this.state;
    const checked = protectedInputs[inputName];
    if (checked !== undefined) {
      this.setState({
        protectedInputs: {...protectedInputs, [inputName]: !checked},
      });
    }
  }

  changeChampionship(championship) {
    this.setState({championship});
    this.props.history.replace({
      pathname: this.props.location.pathname,
      search: `?championship=${championship}`,
    });
  }

  componentDidMount() {
    this.fetchPlayersList();
    this.props.dispatch(
      getChampionshipClubsByChampionshipId(
        (championshipClubsByChampionshipId, clubs) => {
          this.setState({
            championshipClubsByChampionshipId,
          });
          this.setState({
            championshipClubsById: clubs,
          });
        },
      ),
    );
    this.props.dispatch(
      getNextGameWeekByChampiomshipId({
        championshipId: this.state.championship,
        onSuccess: response => {
          this.setState({nextGameWeek: response.gameWeek.gameWeekNumber});
          this.props.dispatch(
            fetchTdsIfNeeded({championship: this.state.championship}),
          );
        },
      }),
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.championship !== this.state.championship)
      this.fetchPlayersList();

    if (
      prevState.orderBy !== this.state.orderBy ||
      prevState.sortOrder !== this.state.sortOrder
    )
      this.setState({players: this.orderPlayers(this.state.players)});

    if (
      prevState.filters !== this.state.filters ||
      prevState.onlyActive !== this.state.onlyActive
    )
      this.setState({
        players: this.orderPlayers(
          this.filterPlayers(this.props.players.entities),
        ),
      });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.players.entities !== this.props.players.entities)
      this.setState({
        players: this.filterPlayers(
          this.orderPlayers(nextProps.players.entities),
        ),
      });

    const {info} = this.props.widget;
    const nextInfo = nextProps.widget.info;

    if (info.success !== nextInfo.success || info.error !== nextInfo.error)
      this.displayRequestMessage(nextInfo);
  }

  renderNoResult() {
    return (
      !this.props.widget.info.isFetching && (
        <div className="no-result text-center">
          <h4 className="text-red">
            <i className="fa fa-meh-o" /> Oh! we couldn't find any players
            corresponding to your request.
          </h4>
        </div>
      )
    );
  }

  getRatings(lastMatches) {
    let tab = [];
    for (let i = 0; i <= 3; i++) {
      if (lastMatches && lastMatches[i]) {
        tab.push(
          <td
            key={i}
            className={
              lastMatches[i].playerPerformance &&
              lastMatches[i].playerPerformance.goals
                ? 'bold text-center'
                : 'text-center'
            }>
            {lastMatches[i].playerPerformance &&
              lastMatches[i].playerPerformance.rating}{' '}
            <br />
            {!!(
              lastMatches[i].playerPerformance &&
              lastMatches[i].playerPerformance.goals
            ) && `${'*'.repeat(lastMatches[i].playerPerformance.goals)}`}
          </td>,
        );
      } else
        tab.push(
          <td key={i} className="text-center">
            -
          </td>,
        );
    }
    return tab;
  }

  renderBody() {
    const {players, nextGameWeek, championshipClubsById} = this.state;
    const {tds, widget} = this.props;
    const {info} = widget;

    if (players.length < 1) return this.renderNoResult();
    return (
      <table className="table table-responsive table-striped">
        <thead>
          <tr>
            <th className="id">ID</th>
            <th>
              <a onClick={() => this.selectOrChangeOrder('name')}>
                Name&nbsp;
                <i className={classNames('fa', this.getOrderCaret('name'))} />
              </a>
            </th>
            <th>
              <a onClick={() => this.selectOrChangeOrder('club')}>
                Club&nbsp;
                <i className={classNames('fa', this.getOrderCaret('club'))} />
              </a>
            </th>
            <th>
              <span className="small ml-2">
                <input
                  style={{minWidth: 70}}
                  type="checkbox"
                  id="protected-position"
                  name="protected-position"
                  checked={this.state.protectedInputs.ultraPosition}
                  onChange={() => this.protectInput('ultraPosition')}
                />
                &nbsp;
                <label htmlFor="protected-position">protect</label>
              </span>
              <br />
              <a onClick={() => this.selectOrChangeOrder('ultraPosition')}>
                Ultra&nbsp;
                <i
                  className={classNames(
                    'fa',
                    this.getOrderCaret('ultraPosition'),
                  )}
                />
              </a>
            </th>
            {this.state.dataToggle ? (
              <React.Fragment>
                <th className="text-center">J-3&nbsp;</th>
                <th className="text-center">J-2&nbsp;</th>
                <th className="text-center">J-1&nbsp;</th>
                <th className="text-center">J&nbsp;</th>
                <th className="text-center">
                  <span className="small ml-2">
                    <input
                      type="checkbox"
                      id="protected-position"
                      name="protected-position"
                      checked={this.state.protectedInputs.quotation}
                      onChange={() => this.protectInput('quotation')}
                    />
                    &nbsp;
                    <label htmlFor="protected-position">protect</label>
                  </span>
                  <br />
                  <a onClick={() => this.selectOrChangeOrder('Quotation')}>
                    Quot.&nbsp;
                    <i
                      className={classNames(
                        'fa',
                        this.getOrderCaret('Quotation'),
                      )}
                    />
                  </a>
                </th>
                <th className="text-center">
                  <a onClick={() => this.selectOrChangeOrder('variation')}>
                    +/-&nbsp;
                    <i
                      className={classNames(
                        'fa',
                        this.getOrderCaret('variation'),
                      )}
                    />
                  </a>
                </th>
                <th>
                  <a onClick={() => this.selectOrChangeOrder('Status')}>
                    Status&nbsp;
                    <i
                      className={classNames('fa', this.getOrderCaret('Status'))}
                    />
                  </a>
                </th>
                <th>
                  <span className="small ml-2">
                    <input
                      type="checkbox"
                      id="protected-position"
                      name="protected-position"
                      checked={this.state.protectedInputs.active}
                      onChange={() => this.protectInput('active')}
                    />
                    &nbsp;
                    <label htmlFor="protected-position">protect</label>
                  </span>
                  <br />
                  Active&nbsp;
                </th>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <th className="text-center">
                  <a onClick={() => this.selectOrChangeOrder('Quotation')}>
                    Quot.&nbsp;
                    <i
                      className={classNames(
                        'fa',
                        this.getOrderCaret('Quotation'),
                      )}
                    />
                  </a>
                </th>
                <th className="text-center">Instagram&nbsp;</th>
                <th className="text-center">Twitter&nbsp;</th>
              </React.Fragment>
            )}

            {
              // <th className="quotation">
              //     <a onClick={() => this.selectOrChangeOrder('quotation')}>
              //         Quotation&nbsp;
              //         <i className={classNames('fa', this.getOrderCaret('quotation'))}/>
              //     </a>
              // </th>
            }
          </tr>
        </thead>
        <tbody>
          {map(
            players,
            (
              {
                id,
                firstName,
                lastName,
                clubId,
                position,
                ultraPosition,
                quotation,
                productionQuotation,
                lastMatches,
                active,
                twitter,
                instagram,
              },
              key,
            ) => (
              <tr key={key} id={id} className="player">
                <td className="id" onClick={() => copyToClipboard(id)}>
                  {id && id.replace('mpg_championship_player_', '')}
                </td>
                <th>
                  {firstName} <span className="text-uppercase">{lastName}</span>
                </th>
                <td data-id={clubId} title={clubId}>
                  {championshipClubsById &&
                    championshipClubsById[clubId] &&
                    championshipClubsById[clubId].name['fr-FR']}
                </td>
                <td className="position-ultra">
                  <div
                    className={classNames('form-group text-center select', {
                      'has-success':
                        info.success &&
                        info.lastAction ===
                          'REQUEST_UPDATE_PLAYER_POSITION_ULTRA' &&
                        info.lastPayload.id === id,
                    })}>
                    <select
                      disabled={this.state.protectedInputs.ultraPosition}
                      tabIndex={key + players.length * 2}
                      className="form-control"
                      value={ultraPosition || 0}
                      onChange={e => {
                        players[key].ultraPosition = parseInt(
                          e.target.value,
                          10,
                        );
                        this.setState({players});
                        this.updatePlayerProperty('ultraPosition', key, e);
                      }}>
                      <option value={0}>Unknown</option>
                      <option value={10}>G</option>
                      <option value={20}>DC</option>
                      <option value={21}>DL</option>
                      <option value={30}>MD</option>
                      <option value={31}>MO</option>
                      <option value={40}>A</option>
                    </select>
                    <i
                      className={classNames({
                        'form-control-feedback fa fa-check animated fadeOut':
                          info.success &&
                          info.lastAction ===
                            'REQUEST_UPDATE_PLAYER_POSITION_ULTRA' &&
                          info.lastPayload.id === id,
                      })}
                    />
                  </div>
                </td>
                {this.state.dataToggle ? (
                  <React.Fragment>
                    {this.getRatings(lastMatches)}
                    <td className="text-center quotation">
                      <input
                        tabIndex={key}
                        type="number"
                        disabled={this.state.protectedInputs.quotation}
                        min={0}
                        value={quotation || ''}
                        className="form-control inputQuotation text-center quotationColor"
                        onBlur={e => {
                          const player = this.state.players[key];
                          if (!player || !e.target.value) {
                            swal({
                              title: `Oops...`,
                              type: 'error',
                              html: "Quotation can't be null",
                            });
                          } else {
                            this.props.dispatch(
                              updatePlayer(player.id, {
                                championships: {
                                  [this.state.championship]: {
                                    quotation: player.quotation,
                                  },
                                },
                              }),
                            );
                          }
                        }}
                        onChange={e => {
                          players[key].quotation = parseInt(e.target.value, 10);
                          this.setState({players});
                        }}
                      />
                    </td>
                    <td className="text-center">
                      {quotation - productionQuotation}
                    </td>
                    <td>
                      <Icon
                        type={
                          playerStatusById[
                            nextGameWeek &&
                              tds.data &&
                              tds.data.gameWeeks[nextGameWeek] &&
                              tds.data.gameWeeks[nextGameWeek]
                                .playersStatuses &&
                              tds.data.gameWeeks[nextGameWeek].playersStatuses[
                                id
                              ]
                          ]
                        }
                      />
                    </td>
                    <td className="text-center">
                      <input
                        type="checkbox"
                        id="active"
                        name="protected-position"
                        checked={!!active}
                        disabled={this.state.protectedInputs.active}
                        onChange={e => {
                          players[key].active = ~~e.target.checked;
                          this.setState({players});
                          const player = this.state.players[key];
                          player &&
                            this.props.dispatch(
                              updatePlayer(player.id, {
                                championships: {
                                  [this.state.championship]: {
                                    active: ~~e.target.checked,
                                  },
                                },
                              }),
                            );
                          this.updatePlayerProperty('active', key, e);
                        }}
                      />
                      &nbsp;
                    </td>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <td className="text-center">{quotation}</td>
                    <td className="text-center">
                      <input
                        tabIndex={key}
                        value={instagram || ''}
                        className="form-control"
                        onBlur={e =>
                          this.updatePlayerProperty('instagram', key, e)
                        }
                        onChange={e => {
                          players[key].instagram = e.target.value;
                          this.setState({players});
                        }}
                      />
                    </td>
                    <td className="text-center">
                      <input
                        tabIndex={key}
                        value={twitter || ''}
                        className="form-control"
                        onBlur={e =>
                          this.updatePlayerProperty('twitter', key, e)
                        }
                        onChange={e => {
                          players[key].twitter = e.target.value;
                          this.setState({players});
                        }}
                      />
                    </td>
                  </React.Fragment>
                )}

                {
                  // <th className="quotation">
                  //     <div
                  //         className={classNames('form-group text-center', {
                  //             'has-success': info.success
                  //             && info.lastAction === 'REQUEST_UPDATE_PLAYER_QUOTATION'
                  //             && info.lastPayload.id === id
                  //         })}
                  //     >
                  //         <input
                  //             tabIndex={key}
                  //             type="number" min={0} value={quotation} className="form-control"
                  //             onBlur={e => this.updatePlayerQuotation(key, e)}
                  //             onChange={e => {
                  //                 players[key].quotation = e.target.value;
                  //                 this.setState({ players });
                  //             }}
                  //             onFocus={e => {
                  //                 const focusedInputValue = e.target.value;
                  //                 this.setState({ focusedInputValue });
                  //             }}
                  //         />
                  //         <i className={classNames({
                  //             'form-control-feedback fa fa-check animated fadeOut': info.success
                  //             && info.lastAction === 'REQUEST_UPDATE_PLAYER_QUOTATION'
                  //             && info.lastPayload.id === id
                  //         })}/>
                  //     </div>
                  // </th>
                }
              </tr>
            ),
          )}
        </tbody>
      </table>
    );
  }

  resetFilters = () => {
    document.getElementById('filter1').value = '';
    document.getElementById('filter2').value = '';
    document.getElementById('filter3').value = '';
    document.getElementById('filter4').value = '';
    document.getElementById('filter5').value = '';

    this.setState({
      filters: {},
      orderBy: 'quotation',
      sortOrder: 'desc',
    });
  };

  togglePlayersData = () => this.setState({dataToggle: !this.state.dataToggle});

  toggleOnlyActive = () => this.setState({onlyActive: !this.state.onlyActive});

  importOpta = () => {
    const {dispatch} = this.props;
    const {championship} = this.state;
    swal({
      title: 'Import players from Opta ?',
      type: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    })
      .then(() => {
        dispatch(importOpta({championship}));
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateListProd = () => {
    const {dispatch} = this.props;
    const {championship} = this.state;
    swal({
      title: 'Update championship active players ?',
      type: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    })
      .then(() => {
        dispatch(updateListProd({championship}));
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateDataByChampionshipId = () => {
    const {championship} = this.state;
    const {dispatch} = this.props;
    swal({
      title: `Update ${championshipsById[championship].label} players stats ?`,
      type: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    })
      .then(() => {
        dispatch(updateDataByChampionshipId({championship}));
      })
      .catch(error => {
        console.log(error);
      });
  };

  setRef = key => ref => (this[key] = ref);

  renderCheckPlayersModal() {
    return (
      <div id="checkPlayers" class="modal fade" role="dialog">
        <div class="modal-dialog">
          <div class="modal-body">
            <CheckPlayers
              clubsById={this.state.championshipClubsById}
              ref={this.setRef('checkPlayers')}
              championship={this.props.championship}
            />
          </div>
        </div>
      </div>
    );
  }

  renderJobsStatesModal() {
    return (
      <div id="jobsStates" class="modal fade" role="dialog">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal">
                &times;
              </button>
              <h4 class="modal-title">Jobs states</h4>
            </div>
            <div class="modal-body">
              <JobsStates ref={this.setRef('jobsStates')} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  // applySuggestedQuotations = () => {
  //   const { dispatch, suggestedQuotationsId } = this.props;
  //   swal({
  //     title: 'Apply suggested quotations ?',
  //     type: 'info',
  //     showCloseButton: true,
  //     showCancelButton: true,
  //     focusConfirm: false,
  //     confirmButtonText: 'Yes',
  //     cancelButtonText: 'No'
  //   })
  //     .then(() => {
  //       dispatch(
  //         applySuggestedQuotationsPlayers({ id: suggestedQuotationsId })
  //       ).then(() => this.fetchPlayersList());
  //     })
  //     .catch(error => {
  //       console.log(error);
  //     });
  // };

  renderButtons() {
    return (
      <div>
        <div style={{display: 'flex', flexDirection: 'row'}}>
          <div style={{flex: 1, margin: 8}}>
            <button
              type="button"
              onClick={this.importOpta}
              className="btn btn-info btn-block">
              <i className="fa fa-download" /> Import Opta
            </button>
          </div>
          <div style={{flex: 1, margin: 8}}>
            <button
              type="button"
              onClick={() =>
                this.checkPlayers.open({
                  onSuccess: this.fetchPlayersList,
                })
              }
              data-toggle="modal"
              data-target="#checkPlayers"
              className="btn btn-warning btn-block">
              <i className="fa fa-check" /> Check players
            </button>
          </div>
          <div style={{flex: 1, margin: 8}}>
            <button
              type="button"
              onClick={() =>
                this.checkPlayers.open({
                  onSubmit: this.updateListProd,
                  title: 'Update championship active players ?',
                })
              }
              data-toggle="modal"
              data-target="#checkPlayers"
              className="btn btn-danger btn-block">
              <i className="fa fa-refresh" /> Update list prod
            </button>
          </div>
          <div style={{flex: 1, margin: 8}}>
            <button
              type="button"
              onClick={this.updateDataByChampionshipId}
              className="btn btn-danger btn-block">
              <i className="fa fa-database" /> Update data
            </button>
          </div>
        </div>
        <div className="row m-2">
          <div className="col-sm-4">
            <span className="toggle-opt-in">
              {'Social network '}
              <i
                onClick={this.togglePlayersData}
                className={classNames('fa fa-2x', {
                  'fa-toggle-on': this.state.dataToggle,
                  'fa-toggle-off': !this.state.dataToggle,
                })}
              />
              {' Côte auto'}
            </span>
          </div>
          <div className="col-sm-4">
            <span className="toggle-opt-in">
              {'Non active '}
              <i
                onClick={this.toggleOnlyActive}
                className={classNames('fa fa-2x', {
                  'fa-toggle-on': this.state.onlyActive,
                  'fa-toggle-off': !this.state.onlyActive,
                })}
              />
              {' Active'}
            </span>
          </div>
        </div>
      </div>
    );
  }

  renderFilters() {
    const {championshipClubsByChampionshipId, championship} = this.state;
    const clubOptions = orderBy(
      !!championshipClubsByChampionshipId &&
        championshipClubsByChampionshipId[championship],
      [championship => championship.name['fr-FR']],
      ['asc'],
    );

    return (
      <div className="box-footer">
        <form className="row">
          <div className="col-sm-6 col-md-2">
            <input
              id="filter1"
              type="text"
              className="form-control"
              placeholder="Name of a player"
              onChange={e =>
                this.setState({
                  filters: {
                    ...this.state.filters,
                    name: e.target.value.length > 2 ? e.target.value : '',
                  },
                })
              }
              disabled={this.props.widget.info.isFetching}
            />
          </div>
          <div className="col-sm-6 col-md-2">
            <select
              id="filter2"
              className="form-control"
              value={this.state.filters.club}
              onChange={e =>
                this.setState({
                  filters: {
                    ...this.state.filters,
                    club: e.target.value,
                  },
                })
              }
              disabled={this.props.widget.info.isFetching}>
              <option value="">All clubs</option>
              {clubOptions.map((club, key) => (
                <option key={key} value={club.id}>
                  {club.name['fr-FR']}
                </option>
              ))}
            </select>
          </div>
          <div className="col-sm-6 col-md-2">
            <select
              id="filter3"
              className="form-control"
              value={this.state.filters.position}
              onChange={e =>
                this.setState({
                  filters: {
                    ...this.state.filters,
                    position: e.target.value,
                  },
                })
              }
              disabled={this.props.widget.info.isFetching}>
              <option value="">All positions</option>
              <option value="1">Goal Keepers</option>
              <option value="2">Defenders</option>
              <option value="3">Midfielders</option>
              <option value="4">Strikers</option>
            </select>
          </div>
          <div className="col-sm-6 col-md-2">
            <select
              id="filter4"
              className="form-control"
              value={this.state.filters.ultraPosition}
              onChange={e =>
                this.setState({
                  filters: {
                    ...this.state.filters,
                    ultraPosition: e.target.value,
                  },
                })
              }
              disabled={this.props.widget.info.isFetching}>
              <option value="">All Ultra positions</option>
              <option value={null}>Unknown</option>
              <option value="10">Goal Keepers</option>
              <option value="20">Defenders</option>
              <option value="21">Wing Back</option>
              <option value="30">Defensive Midfielders</option>
              <option value="31">Attacking Midfielders</option>
              <option value="40">Strikers</option>
            </select>
          </div>
          <div className="col-sm-6 col-md-2">
            <select
              id="filter5"
              className="form-control"
              value={this.state.filters.quotation}
              onChange={e =>
                this.setState({
                  filters: {
                    ...this.state.filters,
                    quotation: e.target.value,
                  },
                })
              }
              disabled={this.props.widget.info.isFetching}>
              <option value="">All quotations</option>
              <option value="10">More than 10</option>
              <option value="20">More than 20</option>
              <option value="30">More than 30</option>
            </select>
          </div>
          <div className="col-sm-6 col-md-2">
            <button
              type="button"
              onClick={this.resetFilters}
              className="btn btn-warning buttonReset btn-block">
              <i className="fa fa-times" /> Reset filters
            </button>
          </div>
        </form>
      </div>
    );
  }

  render() {
    const {isFetching, widget} = this.props;
    const {championship} = this.state;
    return (
      <div id="full-players-list-widget" className="row">
        <div className="col-md-12">
          <div className="row m-2">
            <div className="col-sm-6">
              <button
                type="button"
                onClick={() => this.jobsStates.open()}
                className="btn btn-primary btn-block"
                data-toggle="modal"
                data-target="#jobsStates">
                <i className="fa fa-info" /> Get job states
              </button>
            </div>
          </div>
          <div className="box box-default">
            <div className="box-header with-border">
              <h3 className="box-title pull-left">
                <i className="fa fa-address-card-o" /> Players list
              </h3>
              <div className="box-tools pull-right">
                <ChampionshipSelector
                  championship={championship}
                  onChange={c => this.changeChampionship(c)}
                />
              </div>
            </div>
            {this.renderCheckPlayersModal()}
            {this.renderJobsStatesModal()}
            {this.renderButtons()}
            {this.renderFilters()}
            <div className="box-body">{this.renderBody()}</div>
            {(isFetching || widget.info.isFetching) && <Loader />}
          </div>
        </div>
      </div>
    );
  }
}

PlayersListWidget.propTypes = {
  championship: PropTypes.number,
};

export default withRouter(
  connect(
    state => ({
      widget: {info: state.app.onSite.players.listWidget.info},
      isFetching: state.app.players.info.isFetching,
      players: {entities: state.app.players.response.players},
      lastGameWeekPlayed: state.app.players.response.lastGameWeekPlayed,
      suggestedQuotationsId: state.app.players.response.suggestedQuotationsId,
      tds: state.app.tools.tds,
    }),
    dispatch => ({dispatch}),
  )(PlayersListWidget),
);



// WEBPACK FOOTER //
// ./src/pages/OnSite/FullPlayers/Widgets/PlayersList/index.js